import { render, staticRenderFns } from "./ClearanceApprovalResponseCardHistory.vue?vue&type=template&id=7187e828&"
import script from "./ClearanceApprovalResponseCardHistory.vue?vue&type=script&lang=ts&"
export * from "./ClearanceApprovalResponseCardHistory.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
installComponents(component, {VIcon,VListItemSubtitle})
